<template>
  <div class="animated">
    <AnalyteResultServerTable
      v-if="analyte_result_collection"
      :collection="analyte_result_collection"
      :show_columns="[
        'analyte',
        'result'
      ]"
    />
  </div>
</template>

<script>
import AnalyteResultServerTable from '@/components/lab/analyte/AnalyteResultServerTable'
import AnalyteResultCollection from '@/collections/lab/AnalyteResultCollection'

export default {
  name: 'SampleResultTable',
  components: {
    AnalyteResultServerTable
  },
  props: {
  },
  data () {
    return {
      sample_id: this.$route.params.id || null,
      analyte_result_collection: null
    }
  },
  async created () {
    const collection = new AnalyteResultCollection()
    const filter = collection.getFilter()
    filter.filterEquals('sample_id', this.sample_id)

    filter.cacheStaticFilters()
    this.analyte_result_collection = collection
  }
}
</script>
